import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'prismjs/themes/prism-coy.css';
import './assets/styles/layout.scss';
import './assets/demo/flags/flags.css';

import { createApp, reactive } from 'vue';
import router from './router';

// Pinia
import { createPinia } from "pinia";
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
// Pinia stores
import { useAuthStore } from '@/store/auth'

// Internationalization
import i18n from './locale/i18n'
// import enUS from './assets/i18n/en.json'
// import jaJP from './assets/i18n/ja.json'


import AppWrapper from './AppWrapper.vue';
import PrimeVue from 'primevue/config';
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Avatar from 'primevue/avatar';
import AvatarGroup from 'primevue/avatargroup';
import Badge from 'primevue/badge';
import BadgeDirective from 'primevue/badgedirective';
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chip from 'primevue/chip';
import Chips from 'primevue/chips';
import ColorPicker from 'primevue/colorpicker';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmationService from 'primevue/confirmationservice';
import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import Dropdown from 'primevue/dropdown';
import DynamicDialog from 'primevue/dynamicdialog';
import Editor from 'primevue/editor';
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
// import FullCalendar from 'primevue/fullcalendar'
import Image from 'primevue/image';
import InlineMessage from 'primevue/inlinemessage';
import Inplace from 'primevue/inplace';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import Knob from 'primevue/knob';
import Galleria from 'primevue/galleria';
import Listbox from 'primevue/listbox';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import ProgressSpinner from 'primevue/progressspinner'
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import Ripple from 'primevue/ripple';
import Row from 'primevue/row'; 
import SelectButton from 'primevue/selectbutton';
import ScrollPanel from 'primevue/scrollpanel'
import ScrollTop from 'primevue/scrolltop';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import Skeleton from 'primevue/skeleton';
import SplitButton from 'primevue/splitbutton';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import Steps from 'primevue/steps';
import StyleClass from 'primevue/styleclass';
import TabMenu from 'primevue/tabmenu';
import Tag from 'primevue/tag';
import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Timeline from 'primevue/timeline';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tooltip from 'primevue/tooltip';
import ToggleButton from 'primevue/togglebutton';
import Tree from 'primevue/tree';
import TreeSelect from 'primevue/treeselect';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';

import CodeHighlight from './AppCodeHighlight';
import BlockViewer from './BlockViewer.vue';

import OnMountedFocus from './directives/MountedFocus';

import BlockUI  from 'primevue/blockui';


import CreateButton from "@/components/common/button/CreateButton.vue";
import SaveButton from "@/components/common/button/SaveButton.vue";
import DeleteButton from "@/components/common/button/DeleteButton.vue";
import XButton from "@/components/common/button/XButton.vue";

import SubmitAuthenticatorDialog from "@/components/common/dialog/SubmitAuthenticatorDialog.vue";
import XInputText from "@/components/common/input/XInputText.vue";
import XTitleLabel from "@/components/common/label/XTitleLabel.vue";
import XDropdown from "@/components/common/dropDown/XDropdown.vue";
import XTimeDropDown from '@/components/common/dropDown/XTimeDropDown.vue';
import XCalendar from "@/components/common/calendar/XCalendar.vue";
import XCalendarClean from "@/components/common/calendar/XCalendarClean.vue";
import XInputNumber from "@/components/common/input/XInputNumber.vue";
import XTextarea from "@/components/common/input/XTextarea.vue";
import XMultiSelect from "@/components/common/multi-select/XMultiSelect.vue";
import XAllSelect from "@/components/common/multi-select/XAllSelect.vue";
import XChip from "@/components/common/chip/XChip.vue";
import XPageDataTable from "@/components/common/table-limit/XPageDataTable.vue";
import XDataTable from "@/components/common/table-limit/XDataTable.vue";
import XTitleIconLabel from "@/components/common/label/XTitleIconLabel.vue";
import X1Button from "@/components/common/button/X1Button.vue";
import X1Calendar from "@/components/common/calendar/X1Calendar.vue";
import X1DashboardCalendar from "@/components/common/calendar/X1DashboardCalendar.vue";
import X1Dropdown from "@/components/common/dropDown/X1Dropdown.vue";
import X1Datatable from "@/components/common/table-limit/X1Datatable.vue";
import X1DatatablePaginatorend from "@/components/common/table-limit/X1DatatablePaginatorend.vue";
import X1CalendarDrop from "@/components/common/calendar/X1CalendarDrop.vue";
import { ToastControl } from '@/utils/ToastControl';

// import axios from 'axios';

router.beforeEach(function(to, from, next) {
    window.scrollTo(0, 0);
    next();
});

const app = createApp(AppWrapper);

// HOTELOS_DEV-194 料金カレンダー add start
app.use(PrimeVue, {
    locale: {
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
        monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        monthNamesShort: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        firstDayOfWeek: 1,
    }
});
// HOTELOS_DEV-194 料金カレンダー add end

// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// axios.defaults.withCredentials = true;


app.config.globalProperties.$appState = reactive({ theme: 'lara-light-indigo', darkTheme: false });
app.provide("$appState", app.config.globalProperties.$appState);

app.use(PrimeVue, { ripple: true, inputStyle: 'outlined' });
app.use(ConfirmationService);
app.use(ToastService);
app.use(router);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

const authStore = useAuthStore()

// Internationalization
app.use(i18n);

// Sakai Component
app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple);
app.directive('code', CodeHighlight);
app.directive('badge', BadgeDirective);
app.directive('styleclass', StyleClass);

app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('AutoComplete', AutoComplete);
app.component('Avatar', Avatar);
app.component('AvatarGroup', AvatarGroup);
app.component('Badge', Badge);
app.component('Breadcrumb', Breadcrumb);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Card', Card);
app.component('Carousel', Carousel);
app.component('Chart', Chart);
app.component('Checkbox', Checkbox);
app.component('Chip', Chip);
app.component('Chips', Chips);
app.component('ColorPicker', ColorPicker);
app.component('Column', Column);
app.component('ColumnGroup', ColumnGroup);
app.component('ConfirmDialog', ConfirmDialog);
app.component('ConfirmPopup', ConfirmPopup);
app.component('ContextMenu', ContextMenu);
app.component('Editor', Editor);
app.component('DataTable', DataTable);
app.component('DataView', DataView);
app.component('DataViewLayoutOptions', DataViewLayoutOptions);
app.component('Dialog', Dialog);
app.component('Divider', Divider);
app.component('Dropdown', Dropdown);
app.component('DynamicDialog', DynamicDialog);
app.component('Fieldset', Fieldset);
app.component('FileUpload', FileUpload);
// app.component('FullCalendar', FullCalendar);
app.component('Image', Image);
app.component('InlineMessage', InlineMessage);
app.component('Inplace', Inplace);
app.component('InputMask', InputMask);
app.component('InputNumber', InputNumber);
app.component('InputSwitch', InputSwitch);
app.component('InputText', InputText);
app.component('Galleria', Galleria);
app.component('Knob', Knob);
app.component('Listbox', Listbox);
app.component('MegaMenu', MegaMenu);
app.component('Menu', Menu);
app.component('Menubar', Menubar);
app.component('Message', Message);
app.component('MultiSelect', MultiSelect);
app.component('OrderList', OrderList);
app.component('OrganizationChart', OrganizationChart);
app.component('OverlayPanel', OverlayPanel);
app.component('Paginator', Paginator);
app.component('Panel', Panel);
app.component('PanelMenu', PanelMenu);
app.component('Password', Password);
app.component('PickList', PickList);
app.component('ProgressBar', ProgressBar);
app.component('ProgressSpinner', ProgressSpinner);
app.component('RadioButton', RadioButton);
app.component('Rating', Rating);
app.component('Row', Row);
app.component('SelectButton', SelectButton);
app.component('ScrollPanel', ScrollPanel);
app.component('ScrollTop', ScrollTop);
app.component('Slider', Slider);
app.component('Sidebar', Sidebar);
app.component('Skeleton', Skeleton);
app.component('SplitButton', SplitButton);
app.component('Splitter', Splitter);
app.component('SplitterPanel', SplitterPanel);
app.component('Steps', Steps);
app.component('TabMenu', TabMenu);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Tag', Tag);
app.component('Textarea', Textarea);
app.component('TieredMenu', TieredMenu);
app.component('Timeline', Timeline);
app.component('Toast', Toast);
app.component('Toolbar', Toolbar);
app.component('ToggleButton', ToggleButton);
app.component('Tree', Tree);
app.component('TreeSelect', TreeSelect);
app.component('TreeTable', TreeTable);
app.component('TriStateCheckbox', TriStateCheckbox);

app.component('BlockViewer', BlockViewer);

app.component('BlockUI', BlockUI);
// `v-focus` と呼ばれるグローバルカスタムディレクティブを登録します
app.directive('focus', OnMountedFocus);

app.component('XInputText', XInputText);
app.component('XTitleLabel', XTitleLabel);
app.component('XDropdown', XDropdown);
app.component('XCalendar', XCalendar);
app.component('XCalendarClean', XCalendarClean);
app.component('XInputNumber', XInputNumber);
app.component('XTextarea', XTextarea);
app.component('XMultiSelect', XMultiSelect);
app.component('XAllSelect', XAllSelect);
app.component('XTimeDropDown', XTimeDropDown);
app.component('CreateButton',CreateButton);
app.component('SaveButton',SaveButton);
app.component('DeleteButton',DeleteButton);
app.component('SubmitAuthenticatorDialog',SubmitAuthenticatorDialog);
app.component('XChip',XChip);
app.component('XPageDataTable',XPageDataTable);
app.component('XButton', XButton);
app.component('XDataTable', XDataTable);
app.component('XTitleIconLabel', XTitleIconLabel);
app.component('X1Datatable', X1Datatable);
app.component('X1Dropdown', X1Dropdown);
app.component('X1Calendar', X1Calendar);
app.component('X1Button', X1Button);
app.component('X1DatatablePaginatorend', X1DatatablePaginatorend);
app.component('X1DashboardCalendar', X1DashboardCalendar);
app.component('X1CalendarDrop', X1CalendarDrop);
app.mount('#app');